var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "sticky top-0 z-50 flex items-center justify-between w-screen gap-4 px-6 h-15 bg-pure-white"
    },
    [
      _vm.currentUser.id
        ? _c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })
        : _c("div"),
      _vm._v(" "),
      _vm.report.status === "unpublished"
        ? _c(
            "div",
            { staticClass: "flex items-center flex-shrink-0 gap-4" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center flex-shrink-0 h-6 gap-2 px-2 rounded-full bg-success-100"
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    class: { "animate-spin": _vm.saving },
                    attrs: { icon: "update", color: "success" }
                  }),
                  _vm._v(" "),
                  _vm.saving
                    ? _c("BlTextBody2", {
                        staticClass: "text-success",
                        attrs: { text: "Saving changes" }
                      })
                    : _c("BlTextBody2", {
                        staticClass: "text-success",
                        attrs: { text: "All changes saved" }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex px-1 py-1 bg-slate-400",
                  style: { borderRadius: "8px", height: "2.375rem" }
                },
                _vm._l(_vm.modeOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass:
                        "flex items-center justify-center flex-shrink-0 h-full transition-all duration-300 rounded cursor-pointer w-30",
                      class:
                        _vm.mode === opt.value
                          ? "bg-pure-white"
                          : "bg-slate-400",
                      on: {
                        click: function($event) {
                          return _vm.$emit("change-mode", opt.value)
                        }
                      }
                    },
                    [_c("BlTextSubtitle3", { attrs: { text: opt.label } })],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { label: "Publish report" },
                on: {
                  clicked: function($event) {
                    _vm.publishOpened = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.report.status === "published"
        ? _c(
            "div",
            { staticClass: "flex items-center gap-2 truncate" },
            [
              _vm.report.user
                ? _c(
                    "div",
                    { staticClass: "truncate" },
                    [
                      _c("BlTextBody3", { attrs: { text: "Published on" } }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        attrs: {
                          text: _vm.displayDate({
                            date:
                              _vm.report.published_at || _vm.report.updated_at
                          })
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody3", { attrs: { text: "by" } }),
                      _vm._v(" "),
                      !_vm.report.user
                        ? _c("BlTextBody3", {
                            staticClass: "italic",
                            attrs: { text: "Deleted user" }
                          })
                        : _c("BlTextBody3", {
                            attrs: { text: _vm.report.user.name }
                          })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("BlTextBody3", { attrs: { text: "Published on " } }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        attrs: {
                          text: _vm.displayDate({
                            date:
                              _vm.report.published_at || _vm.report.updated_at
                          })
                        }
                      })
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("BlChip", { attrs: { chip: "published", dense: "" } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.publishOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Confirm report publishing",
              label: "Publish",
              description:
                "By publishing this report, you will no longer be able to make changes. Please double-check your report before proceeding.",
              empty: "",
              submitLoading: _vm.publishLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.publishOpened = false
              },
              "backdrop-action": _vm.onPublish
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ab6f6e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab6f6e1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ReportHeader.vue
// module id = null
// module chunks = 